import React from 'react';
import {connect} from "react-redux";
import {Calendar} from "antd";
import {injectIntl} from "react-intl";
import withAuthorization from "../../../services/Authorization";
import LoadingIndicator from "../../common/loading/LoadingIndicator";
import moment from 'moment';
import SetRentalsMenu from "./SetRentalsMenu";
import Constants from "../../../services/Constants";
import Time from "../../../services/Time";

class RentalPlanning extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      setRentalsModalOpen: false,
      selectedDay: moment().format(Constants.DATE_FORMAT_API),
      rentingManual: true,
      hasMotorbike: false,
      planning: {}
    };
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const {fetchRentalPlanning, fetchRentalVehicles} = this.props;
    const {configurationHints} = this.state;
    if (configurationHints) {
      const fetchPlanning = configurationHints && !configurationHints.includes("MOBILITY") && !configurationHints.includes("MAIN_SERVICES");
      if (fetchPlanning && !fetchRentalPlanning.rentalPlanning.planning) {
        !fetchRentalPlanning.loading && this.props.dispatchFetchRentalPlanning(this.state.selectedDay);
        !fetchRentalVehicles.loading && this.props.dispatchFetchRentalVehicles();
      }
    }
  }

  componentWillReceiveProps = nextProps => {
    if (nextProps.fetchMainServices && nextProps.fetchMainServices.mainServices && !nextProps.fetchMainServices.loading) {
      this.setState({rentingManual: nextProps.fetchMainServices.mainServices.manualRentalCarPlanning})
    }
    if (nextProps.fetchMobility && nextProps.fetchMobility.mobility && nextProps.fetchMobility.mobility.otherMobility && !nextProps.loading) {
      const motorbike = nextProps.fetchMobility.mobility.otherMobility["motorbike"] || {};
      this.setState({hasMotorbike: motorbike.active});
    }
    if (nextProps.configurationHints) {
      this.setState({configurationHints: nextProps.configurationHints})
    }
  };

  save = () => {
    this.props.dispatchSaveRentalPlanning({planning: this.state.planning});
  };

  updateCalendarRange = (date) => {
    if (moment(this.state.selectedDay).year() !== moment(date).year()) {
      this.props.dispatchFetchRentalPlanning(moment(date).format(Constants.DATE_FORMAT_API));
    }
  };

  onSelectDate = (date) => {
    this.updateCalendarRange(date);
    this.setState({
      selectedDay: moment(date).format(Constants.DATE_FORMAT_API),
      setRentalsModalOpen: this.isOpeningDay(date) && this.state.rentingManual
    });
  };

  dateFullCellRender = (date) => {
    const {fetchRentalPlanning: {rentalPlanning}} = this.props;
    const {planning} = this.state;
    const initialPlanning = rentalPlanning.planning || {};

    const currentDay = moment(date).format("D");
    const formattedDate = moment(date).format(Constants.DATE_FORMAT_API);

    let currentData = planning[formattedDate] || initialPlanning[formattedDate] || {};
    currentData = this.computeMaxRentals(currentData);
    const colorClass = this.computeCellColor(date, currentData);

    return (
      <div className={colorClass + " ant-fullcalendar-date"}>
        <div className="ant-fullcalendar-value h4-like">{currentDay}</div>
        {this.renderAvailabilities(date, currentData)}
      </div>
    )
  };

  computeCellColor = (day, data) => {
    const currentCars = data.currentRentalCars || 0;
    const maxCars = data.maxRentalCars;
    if (Time.beforeToday(day)) {
      return "calendar-box--expired";
    }
    return (!this.isOpeningDay(day)) ? "" : ((currentCars !== maxCars) ? "calendar-box--available" : "calendar-box--unavailable");
  };

  isOpeningDay(day) {
    const {fetchPlanningManagement: {planningManagement = {}}} = this.props;
    const planning = planningManagement.planning || {};
    const currentWeekDay = Time.dayOfWeekAsStringUppercase(day);
    return (planning[currentWeekDay] && planning[currentWeekDay].slots && planning[currentWeekDay].slots.length > 0);
  }

  renderAvailabilities = (date, data) => {
    const {intl: {formatMessage}} = this.props;
    const {maxRentalCars = 0, maxRentalMotorbikes = 0, currentRentalCars = 0, currentRentalMotorbikes = 0} = data;

    if (!this.isOpeningDay(date)) {
      return null;
    }
    return (
      <div style={{marginTop: '5%', textAlign: 'center'}}>
        <div>{formatMessage({id: 'rental-planning.cars.label'})}: {currentRentalCars} / {maxRentalCars}</div>
        {this.state.hasMotorbike &&
        <div>{formatMessage({id: 'rental-planning.motorbikes.label'})}: {currentRentalMotorbikes} / {maxRentalMotorbikes}</div>
        }
      </div>
    )
  };

  computeMaxRentals(data) {
    const {fetchRentalVehicles: {rentals: {rentals = []}}} = this.props;
    if (!this.state.rentingManual && rentals.length > 0) {
      data.maxRentalCars = rentals.filter(r => r.category !== "MOTORBIKE").length;
      data.maxRentalMotorbikes = rentals.filter(r => r.category === "MOTORBIKE").length;
    }
    return data;
  }

  onDayChange = (date, maxRentalCars, maxRentalMotorbikes) => {
    const {planning = {}} = this.state;
    planning[date] = planning[date] || {};
    planning[date].day = date;
    planning[date].maxRentalCars = maxRentalCars;
    planning[date].maxRentalMotorbikes = maxRentalMotorbikes;
    this.setState({planning});
  };

  onCalendarRangeChange = (date) => {
    this.updateCalendarRange(date);
    this.setState({
      selectedDay: moment(date).format(Constants.DATE_FORMAT_API)
    });
  };

  render() {
    const {intl: {formatMessage}, fetchRentalPlanning: {loading, rentalPlanning}, configurationHints} = this.props;
    const {planning = {}, rentingManual, setRentalsModalOpen, selectedDay, hasMotorbike} = this.state;

    return (
      <section className="box rental-planning">
        <header className="box-heading">
          <h2 className="box-heading__title">
            {formatMessage({id: 'section.rental-planning.title'})}
          </h2>
          <div className="box-heading__button">
            {rentingManual &&
              <button onClick={this.save} type="primary" className="btn btn-sm btn-primary">{formatMessage({id: 'action.save'})}</button>
            }
          </div>
        </header>
        {
          (loading) ? (
            <LoadingIndicator/>
          ) : (
            <div className="box__body">
              {!rentalPlanning || !rentalPlanning.planning ? (
                <div className="alert alert--error">{formatMessage({id: 'configuration.rental-planning.not-available'})}</div>
              ) : (
                <React.Fragment>
                  <Calendar className="calendar--hidden-year"
                            onSelect={this.onSelectDate}
                            dateFullCellRender={this.dateFullCellRender}
                            onPanelChange={this.onCalendarRangeChange}
                            value={moment(selectedDay)}
                  />
                  <SetRentalsMenu visible={setRentalsModalOpen}
                                  onModalClose={() => this.setState({setRentalsModalOpen: false})}
                                  onModalDayChange={this.onDayChange}
                                  date={selectedDay}
                                  data={planning[selectedDay]}
                                  hasMotorbike={hasMotorbike}
                  />
                </React.Fragment>
              )}
            </div>
          )
        }
      </section>
    )
  }
}

const mapStateToProps = state => ({
  fetchRentalPlanning: state.fetchRentalPlanning,
  saveRentalPlanning: state.saveRentalPlanning,

  fetchPlanningManagement: state.fetchPlanningManagement,
  savePlanningManagement: state.savePlanningManagement,

  fetchMobility: state.fetchMobility,
  fetchMainServices: state.fetchMainServices,
  fetchRentalVehicles: state.fetchRentalVehicles,
  configurationHints: state.dealerConfigurationCheck && state.dealerConfigurationCheck.configurationHints,

});

const mapDispatchToProps = dispatch => ({
  dispatchFetchRentalPlanning: (day) => dispatch({type: 'FETCH_RENTAL_PLANNING.REQUEST', day}),
  dispatchSaveRentalPlanning: (body) => dispatch({type: 'SAVE_RENTAL_PLANNING.REQUEST', body}),
  dispatchFetchRentalVehicles: () => dispatch({type: 'FETCH_RENTAL_VEHICLES.REQUEST'})
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withAuthorization(injectIntl(RentalPlanning), ['DUI_ADMIN', 'DUI_SERVICE_ADVISOR']));



// WEBPACK FOOTER //
// ./src/components/planning/management/RentalPlanning.js